import React from 'react';
export const AzureBlobIcon = () => {
	return (
		<svg
			width="48"
			height="48"
			viewBox="0 0 48 48"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				width="48"
				height="48"
				rx="2"
				fill="white"
				fillOpacity="0.9"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M35.779 4H13.2205L2 24L13.2205 44H35.779L47 24L35.779 4ZM35.896 32.982C35.896 34.6585 34.4935 36.0955 32.857 36.0955H16.26C14.6235 36.0955 13.221 34.6585 13.221 32.982V15.138C13.221 13.4615 14.6235 12.024 16.26 12.024H28.5325H30.87H31.221L35.8965 16.8145V19.3295V32.9825L35.896 32.982ZM22.805 27.2335C22.805 26.994 22.688 26.8745 22.688 26.7545C22.688 26.6345 22.571 26.515 22.4545 26.3955C22.338 26.276 22.3375 26.2755 22.2205 26.2755H21.87C21.636 26.2755 21.519 26.2755 21.4025 26.3955C21.286 26.5155 21.1685 26.635 21.052 26.8745C20.9355 27.114 20.935 27.3535 20.935 27.593V28.671V29.8685C20.935 30.228 21.052 30.467 21.169 30.587C21.286 30.8265 21.403 30.9465 21.5195 30.9465C21.6365 31.0665 21.7535 31.0665 21.987 31.0665C22.104 31.0665 22.221 31.0665 22.3375 30.9465C22.3988 30.9415 22.4563 30.9146 22.4993 30.8705C22.5423 30.8265 22.568 30.7684 22.5715 30.707C22.6885 30.587 22.6885 30.4675 22.805 30.348C22.805 30.228 22.922 30.1085 22.922 29.869C22.922 29.7495 22.922 29.5095 23.0385 29.27V28.5515V27.7135C22.805 27.5935 22.805 27.474 22.805 27.2345V27.2335ZM28.065 17.892C28.065 17.6525 27.948 17.533 27.948 17.413C27.948 17.293 27.831 17.1735 27.714 17.0535C27.597 16.9335 27.597 16.9335 27.48 16.9335H27.1295C26.896 16.9335 26.779 16.9335 26.662 17.0535C26.545 17.1735 26.428 17.293 26.311 17.5325C26.194 17.772 26.1945 18.0115 26.1945 18.251V19.329V20.5265C26.1945 20.886 26.311 21.1255 26.428 21.245C26.545 21.4845 26.662 21.6045 26.7785 21.6045C26.8955 21.7245 27.012 21.7245 27.246 21.7245C27.363 21.7245 27.4795 21.7245 27.5965 21.6045C27.6578 21.5995 27.7153 21.5726 27.7583 21.5285C27.8013 21.4845 27.827 21.4264 27.8305 21.365C27.9475 21.245 27.9475 21.1255 28.0645 21.0055C28.0645 20.886 28.1815 20.766 28.1815 20.5265C28.1815 20.407 28.1815 20.1675 28.2985 19.9275V19.209V18.3705C28.1815 18.3705 28.1815 18.131 28.065 17.8915V17.892ZM30.4025 13.7005H28.5325H16.26C15.442 13.7005 14.8575 14.2995 14.8575 15.1375V32.982C14.8575 33.8205 15.442 34.419 16.26 34.419H32.8575C33.2324 34.4092 33.5886 34.2536 33.8505 33.9853C34.1124 33.7169 34.2593 33.357 34.26 32.982V17.6525H30.52V13.7005H30.4025ZM20 17.2935V17.174V17.054L20.117 16.934L21.5195 15.976H21.6365H21.7535H21.8705H22.1045H22.455H22.6885H22.8055V16.096V21.725H23.8575H23.9745L24.091 21.845C24.208 21.9645 24.091 21.9645 24.091 21.9645V22.204V22.4435V22.563C24.091 22.563 24.091 22.683 23.9745 22.683H23.8575H20.234H20.117L20 22.563V22.4435V22.204V21.9645V21.845C20 21.845 20 21.725 20.117 21.725H20.234H21.5195V17.294L20.4675 17.893C20.3505 17.893 20.3505 18.0125 20.234 18.0125H20.117C20.117 18.0125 20.117 17.893 20 17.893V17.534V17.2945V17.2935ZM24.091 30.108C23.9745 30.587 23.8575 30.9465 23.6235 31.186C23.3895 31.545 23.156 31.785 22.922 31.9045C22.5715 32.024 22.2205 32.144 21.753 32.144C21.2855 32.144 20.935 32.024 20.584 31.9045C20.417 31.8517 20.2656 31.7584 20.1433 31.6331C20.0209 31.5078 19.9313 31.3542 19.8825 31.186C19.7655 30.827 19.532 30.4675 19.532 30.108C19.415 29.629 19.415 29.15 19.415 28.671C19.415 28.072 19.415 27.593 19.532 27.234C19.649 26.755 19.7655 26.3955 19.9995 26.156C20.2335 25.9165 20.467 25.557 20.701 25.4375C21.0515 25.3175 21.4025 25.198 21.87 25.198C22.3375 25.198 22.688 25.3175 23.0385 25.4375C23.2055 25.4903 23.3569 25.5836 23.4792 25.7089C23.6016 25.8342 23.6912 25.9878 23.74 26.156C23.857 26.5155 24.0905 26.8745 24.0905 27.234C24.2075 27.713 24.2075 28.192 24.2075 28.671C24.2075 29.27 24.2075 29.749 24.0905 30.108H24.091ZM29.351 31.7845V31.9045C29.351 31.9045 29.351 32.024 29.234 32.024H29.117H25.4935H25.3765L25.2595 31.9045V31.7845V31.545V31.3055V31.186C25.2595 31.186 25.2595 31.0665 25.3765 31.0665H25.4935H26.7795V26.6355L25.7275 27.2345C25.6105 27.2345 25.6105 27.354 25.4935 27.354H25.3765C25.3765 27.354 25.3765 27.2345 25.2595 27.2345V26.8755V26.636V26.5165V26.3965L25.3765 26.2765L26.779 25.3185H26.896H27.013H27.13H27.364H27.7145H27.9485H28.0655V25.4385V31.0675H29.1175H29.2345L29.3515 31.187V31.3065V31.546V31.7855L29.351 31.7845ZM29.468 20.7665C29.351 21.2455 29.234 21.605 29.0005 21.8445C28.7665 22.2035 28.533 22.4435 28.299 22.563C27.9485 22.683 27.5975 22.8025 27.13 22.8025C26.6625 22.8025 26.312 22.6825 25.961 22.563C25.794 22.5102 25.6426 22.4169 25.5203 22.2916C25.3979 22.1663 25.3083 22.0127 25.2595 21.8445C25.1425 21.605 24.909 21.126 24.909 20.7665C24.909 20.407 24.792 19.8085 24.792 19.3295C24.792 18.7305 24.792 18.2515 24.909 17.8925C25.026 17.4135 25.143 17.054 25.3765 16.8145C25.6105 16.4555 25.844 16.2155 26.078 16.096C26.4285 15.976 26.7795 15.8565 27.247 15.8565C27.7145 15.8565 28.065 15.9765 28.416 16.096C28.583 16.1488 28.7344 16.2421 28.8567 16.3674C28.9791 16.4927 29.0687 16.6463 29.1175 16.8145C29.2345 17.1735 29.468 17.533 29.468 17.8925C29.585 18.3715 29.585 18.8505 29.585 19.3295C29.585 19.9285 29.468 20.4075 29.468 20.7665Z"
				fill="#0078D7"
			/>
		</svg>
	);
};

export const S3Icon = () => {
	return (
		<svg
			width="35"
			height="40"
			viewBox="0 0 35 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.81701 6.94149L1.14441e-05 8.27299V31.673L2.81701 33.0045L9.73051 19.9705L2.81701 6.94149Z"
				fill="#8C3123"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.5 29.639L2.81701 33V6.94149L17.5 10.3025L24.439 20.01L17.5 29.639Z"
				fill="#E05243"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.5 29.639L32.178 33L34.7165 20.3025L32.178 6.94149L17.5 10.3025V29.639Z"
				fill="#8C3123"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M32.178 6.94149L35 8.27299V31.673L32.178 33.0045V6.94149Z"
				fill="#E05243"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.0975 24.283L17.5 25.0585L22.5765 20.01L17.5 14.966L11.0975 15.727V24.283Z"
				fill="#8C3123"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23.9025 11.5855L17.5 12.688L11.0975 11.5855L17.5 -7.62939e-06L23.9025 11.5855Z"
				fill="#5E1F18"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23.9025 28.4145L17.5 27.3025L11.0975 28.4145L17.5 40L23.9025 28.4145Z"
				fill="#F2B0A9"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23.9025 11.5855L17.5 10.088V-7.62939e-06L23.9025 3.02449V11.5855Z"
				fill="#E05243"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.0975 11.5855L17.5 10.088V-7.62939e-06L11.0975 3.02449V11.5855Z"
				fill="#8C3123"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.5 40L23.9025 36.9755V28.4145L17.5 29.912V40Z"
				fill="#E05243"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.5 40L11.0975 36.9755V28.4145L17.5 29.912V40Z"
				fill="#8C3123"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23.9025 24.283L17.5 25.0585V14.966L23.9025 15.727V24.283Z"
				fill="#E05243"
			/>
		</svg>
	);
};

export const AzureDataLakeIcon = () => {
	return (
		<svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.14 45.556c-4.39-.453-8.494-1.532-10.576-2.779-1.028-.616-2.02-1.567-2.278-2.183-.164-.391-.216-3.337-.3-16.682-.071-11.416-.056-16.235.051-16.3.084-.052.38.224.664.617.877 1.222 2.304 2.081 4.891 2.947 1.695.567 4.184 1.1 6.19 1.328 2.43.274 6.325.46 7.712.368 6.675-.444 11.32-1.825 13.544-4.029.498-.493.931-.897.964-.897.031 0 .056 7.213.054 16.03-.003 18.212.11 16.607-1.25 17.83-1.693 1.522-4.924 2.7-9.397 3.422-1.474.24-2.632.308-5.771.343-2.16.024-4.184.018-4.498-.015zm.142-35.13c-2.969-.3-5.747-.917-7.297-1.62-4.743-2.15-2.31-4.902 5.37-6.073 2.081-.317 6.905-.436 9.255-.228 4.466.396 7.785 1.329 9.223 2.591 2.217 1.947-.636 4.078-6.787 5.07-1.423.23-8.265.412-9.764.26z"
        fill="#9FA0A1"
      />
      <path
        d="M19.354 45.43c-2.507-.285-4.65-.728-6.608-1.367-2.068-.674-3.477-1.4-4.462-2.301-1.335-1.22-1.24.286-1.124-17.7.056-8.707.121-15.83.145-15.83.023 0 .329.306.678.679 2.015 2.148 6.792 3.604 13.308 4.055l2.49.172V29.52l.75-.094c1.827-.227 3.338-.991 4.521-2.286.388-.424.736-.772.774-.772.038 0 .486.417.995.927 1.65 1.649 3.905 2.43 6.012 2.082 1.188-.196 2.442-.728 3.273-1.39.328-.26.645-.474.704-.475.059 0 .107 2.828.107 6.286 0 7.038.027 6.828-1.02 7.84-1.66 1.606-5.161 2.89-9.761 3.583-2.644.398-8.186.506-10.782.21zm-.392-35.281c-2.975-.36-5.715-1.142-7.003-1.997-2.967-1.97-.66-4.074 5.753-5.246 1.536-.28 2.193-.313 6.354-.313 4.22 0 4.81.03 6.498.33 2.053.366 4.461 1.11 5.428 1.676 3.641 2.134.406 4.692-7.035 5.562-2.27.266-7.758.259-9.995-.012z"
        fill="#58B2D6"
      />
      <path
        d="M18.926 45.13c-4.679-.563-8.6-1.857-10.398-3.43-1.254-1.096-1.145.425-1.258-17.521-.055-8.772-.06-15.948-.011-15.948.048 0 .375.305.724.678 2.015 2.149 6.792 3.604 13.308 4.055l2.49.172V45.36l-1.607-.015a35.744 35.744 0 01-3.248-.213zm.036-34.983c-2.975-.36-5.715-1.141-7.003-1.996-2.967-1.97-.66-4.075 5.753-5.247 1.536-.28 2.193-.313 6.354-.312 4.22 0 4.81.03 6.498.33 2.053.366 4.461 1.109 5.428 1.676 3.641 2.134.406 4.691-7.035 5.562-2.27.265-7.758.258-9.995-.013z"
        fill="#B3D131"
      />
      <path
        d="M18.926 45.13c-4.679-.563-8.6-1.857-10.398-3.43-1.254-1.096-1.145.425-1.258-17.521-.055-8.772-.06-15.948-.011-15.948.048 0 .375.305.724.678 2.015 2.149 6.792 3.604 13.308 4.055l2.49.172V45.36l-1.607-.015a35.744 35.744 0 01-3.248-.213zm1.356-34.997c-1.168-.101-3.606-.505-4.721-.781-1.187-.294-1.614-.473-1.472-.616.168-.168 2.886-.788 4.513-1.03 2.114-.313 8.423-.358 10.391-.073 2.479.36 5.07.96 5.07 1.177 0 .305-3.272 1.024-5.773 1.268-1.423.14-6.63.175-8.008.055z"
        fill="#3897C4"
      />
      <path
        d="M11 29.362c-1.044-.157-2.186-.633-2.999-1.25l-.714-.543-.036-9.669c-.02-5.317-.007-9.668.03-9.668.036 0 .353.305.702.678 2.015 2.148 6.792 3.604 13.308 4.055l2.49.172v16.268l-.941-.076c-1.353-.108-2.862-.88-4.02-2.057-.49-.498-.93-.905-.978-.905-.048 0-.386.333-.75.74C15.514 28.86 13.247 29.7 11 29.362zm9.282-19.229c-1.168-.101-3.606-.505-4.721-.781-1.187-.294-1.614-.473-1.472-.616.168-.168 2.886-.788 4.513-1.03 2.114-.313 8.423-.358 10.391-.073 2.479.36 5.07.96 5.07 1.177 0 .305-3.272 1.024-5.773 1.268-1.423.14-6.63.175-8.008.055z"
        fill="#7EB900"
      />
      <path
        d="M11 29.362c-1.044-.157-2.186-.633-2.999-1.25l-.714-.543-.036-9.669c-.02-5.317-.007-9.668.03-9.668.036 0 .353.305.702.678 2.015 2.148 6.792 3.604 13.308 4.055l2.49.172v16.268l-.941-.076c-1.353-.108-2.862-.88-4.02-2.057-.49-.498-.93-.905-.978-.905-.048 0-.386.333-.75.74C15.514 28.86 13.247 29.7 11 29.362z"
        fill="#3E3E3F"
      />
    </svg>
	);
};